import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGet } from '../hooks/useGet'
import { useDelete } from '../hooks/useDelete'
import { useConfirm } from '../hooks/useConfirm'
import { RadAppLayout } from '../common/RadAppLayout'
import { RadButton } from '../common/RadButton'
import { RadContainer } from '../common/RadContainer'
import { RadHeader } from '../common/RadHeader'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { ProjectDetailContent } from './ProjectDetailContent'

export function ProjectDetail () {
  const navigate = useNavigate()
  const { projectId } = useParams()
  const { data: project } = useGet(`/api/project/${projectId}`, true)
  const { data: currentUser } = useGet('/api/user/current')
  const confirmDelete = useConfirm('Delete project?', 'Delete project permanently? This action cannot be undone.', 'Delete', () => { remove() })
  const remove = useDelete(`/api/project/${projectId}`, () => { navigate('/project') })

  function edit (evt) {
    evt.preventDefault()
    navigate('edit')
  }

  if (project != null && currentUser != null) {
    return (
      <RadAppLayout
        name={project.name}
        contentHeader={
          <RadHeader
            variant='h1'
            actions={
              <RadSpaceBetween direction='horizontal' size='xs'>
                {project.canEdit && <RadButton onClick={edit}>Edit</RadButton>}
                {project.canDelete && <RadButton onClick={confirmDelete} disabled={project.isProtected}>Delete</RadButton>}
              </RadSpaceBetween>
            }
          >
            {project.name}
          </RadHeader>
        }
        content={
          <RadContainer
            header={
              <RadHeader variant='h2'>
                Details
              </RadHeader>
            }
          >
            <ProjectDetailContent project={project} />
          </RadContainer>
        }
      />
    )
  }
}
